import React from 'react'
import { DashboardLayout } from '../layouts'
import { CustomGoogleMap } from '../components'
import { useState } from 'react';
import { useEffect } from 'react';
import services from '../../ioc/services';

function Maps() {

    const [places, setPlaces] = useState(null);


    useEffect(() => {
        services.api.form.getAllResponseWithLocation()
            .then(res => {
                setPlaces(res.map(response => {

                    const gpsName = response.form.fields.find(r => r.key =="gps")?.name;

                    try{
                        const location = response.responseObject[gpsName];

                        if(location == null || location == undefined || location.trim() == ''){
                            return null;
                        }

                        return ({
                            lat: location.split(",")[0],
                            lng: location.split(",")[1],
                            markerData: {
                                responseId: response._id,
                                formId: response.form_id,
                                form: response.form.title,
                                responseDate: response.createdAt,
                                agent: `${response.filledBy.firstName} ${response.filledBy.lastName}`
                            }
                        })
                    }
                    catch(err){
                        return null;
                    }

                    
                }))
            })
            .catch(err => { console.log(err) })
    }, [])

  return (
    <DashboardLayout>
        <div className='h-screen'>
            {places && <CustomGoogleMap places={places}/>}
        </div>
    </DashboardLayout>
  )
}

export default Maps